import { render, staticRenderFns } from "./epb-textbox.component.vue?vue&type=template&id=a39f1fa4&scoped=true"
import script from "./epb-textbox.component.vue?vue&type=script&lang=ts"
export * from "./epb-textbox.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-textbox.component.vue?vue&type=style&index=0&id=a39f1fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39f1fa4",
  null
  
)

export default component.exports